module.exports = __webpack_public_path__ + "img/users-2-svgrepo-com.953f932b.svg";